import { assert } from '@varos/util-typescript';
import { ReportingLoaderBaseConfig } from '../../base';
import { MentionSpanLoader } from './mentionSpanInterface';

export function createMentionSpanLoader(
    config: ReportingLoaderBaseConfig
): MentionSpanLoader {
    const { repository } = config;
    return {
        useLoad(context, props) {
            const contentQuery = repository.research.content.useLookup(
                context,
                {
                    contentId: props.item.mention.id,
                },
                { suspense: false }
            );
            return {
                content:
                    contentQuery.status === 'success'
                        ? {
                              status: contentQuery.status,
                              data: contentQuery.data,
                              error: null,
                          }
                        : {
                              status: 'loading',
                              data: null,
                              error: null,
                          },
            };
        },
    };
}
